import React from 'react';
import PropTypes from 'prop-types';
import { Button as MaterialButton } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const Button = ({
  onClick, style, color, className, variant, disabled, fullWidth, label, children,
}) => (
  <MaterialButton
    onClick={onClick}
    style={style}
    color={color}
    className={className}
    variant={variant}
    disabled={disabled}
    primary={color}
    fullWidth={fullWidth}
  >

    {label}
    {children}
  </MaterialButton>
);

Button.propTypes = {
  onClick: PropTypes.func,
  style: PropTypes.object,
  color: PropTypes.string,
  className: PropTypes.string,
  variant: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  children: PropTypes.any,
  fullWidth: PropTypes.bool,
};

Button.defaultProps = {
  onClick: () => {},
  label: '',
  children: null,
  style: {},
  color: 'default',
  className: '',
  variant: 'text',
  disabled: false,
  fullWidth: false,
};

const styles = {
  label: {
    fontSize: 14,
  },
};

export default withStyles(styles)(Button);
